import { useState } from "react";
import ActionModal from "./ActionModal";
import type { AcceptButtonDetails } from "./types";
import { TextAreaField } from "@/components/common/text-field";

interface Props {
  isLoading?: boolean;
  isOpen: boolean;
  onClose: () => void;
  acceptButtonDetails: AcceptButtonDetails;
  onSendToLead: (comment: string) => void;
}

/**
 * Modal to send a suspension request to the lead for verification.
 * used in the ExtensionMainModal component.
 * used in the ApproveSuspensionInfo component.
 * @param param0
 * @returns
 */
const SendToLeadModal = ({
  isLoading,
  isOpen,
  onClose,
  acceptButtonDetails,
  onSendToLead,
}: Props) => {
  const [comment, setComment] = useState<string>("");

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = event.target.value;
    setComment(value);
  };

  const handleClose = () => {
    setComment("");
    onClose();
  };

  const handleAccept = async () => {
    onSendToLead(comment);
  };

  return (
    <ActionModal
      isOpen={isOpen}
      onClose={handleClose}
      onAccpet={handleAccept}
      title="Enviar al líder"
      description="¿Estás seguro de que deseas delegar la solicitud a tu líder?"
      acceptButtonDetails={{
        ...acceptButtonDetails,
        disabled: comment.length <= 0 || comment.length > 120,
        isLoading,
      }}
    >
      <div>
        <TextAreaField
          required
          id="send-to-lead-reason"
          label="¿Por qué se necesita la verificación de tu líder?"
          value={comment}
          onChange={handleChange}
          placeholder="Escribe tu comentario..."
          limit={120}
          countAlign="right"
          count={comment.length}
        />
      </div>
    </ActionModal>
  );
};

export default SendToLeadModal;
